import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import PropTypes from 'prop-types';
import moment from 'moment-business-days';
import { connect } from 'react-redux';
import { Dialog, IconButton } from 'react-toolbox';
import { clearValidation, updatePhaseTask } from 'actionCreators';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import { handleDateSave } from '../../../../../../utils/dateUtils';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import S from 'modal.scss';

class ReceivedETAModal extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    this.state = { vendorEta: '', errorMessage: false };
  }

  static VALIDATIONS = { vendorEta: true }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  handleEtaChange = (date) => {
    const isDateString = !!date.match(/^\d{2}\/\d{2}\/\d{4}$/);
    if (!isDateString) this.setState({ errorMessage: true });
    else this.setState({ vendorEta: date, errorMessage: false });
  }

  data = () => ({ event: { data: {
    note: `ETA: ${this.state.vendorEta}`,
    vendor_eta: handleDateSave(this.state.vendorEta),
  } } });

  handleSubmit = () => {
    if (this.state.vendorEta === '') {
      this.setState({ errorMessage: true });
    } else {
      if (!this.validate()) return;
      const task = { status: 'complete' };
      const data = this.data();
      this.props.updatePhaseTask(
        this.props.phase.id,
        this.props.task.slug,
        { task, ...data },
      ).then(() => this.handleClose())
       .catch(result => this.setState({
         errorMessage: true, errors: result.payload.errors,
       }));
    }
  }

  render = () => {
    const { vendorEta, errorMessage } = this.state;
    return (<Dialog
      active={this.props.active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5 style={{ textAlign: 'center' }}>Vendor ETA</h5>
      <br />
      <DatePicker
        label="Designate an ETA"
        minDate={moment().toDate()}
        value={vendorEta}
        onChange={event => this.handleEtaChange(event)}
        className={S.datePicker}
        placeholder="Click the calendar icon to select date"
        error={errorMessage.vendorEta}
      />
      {errorMessage ? (<h3
        className="errorMsg"
        style={{ color: 'red', textAlign: 'center', fontSize: '15px' }}
      >
          Please select a valid date before submitting.
          Use the following format: MM/DD/YYYY
        </h3>) : null}
      <div className={S.actions}>
        <ColoredButton
          color="green"
          responsive
          disabled={errorMessage}
          label="Complete Task"
          className={S.button}
          onClick={this.handleSubmit}
        />
        <ColoredButton
          color="darkGray"
          responsive
          label="Cancel"
          className={S.button}
          onClick={this.handleClose}
        />
      </div>
    </Dialog>);
  }
}

ReceivedETAModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
};

ReceivedETAModal.defaultProps = {
  active: false,
};

export default connect(
    state => ({
      errors: state.walkthroughs.uploadError,
    }), {
      clearValidation,
      updatePhaseTask,
    },
  )(ReceivedETAModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/receivedETAModal.jsx